import { WebsiteIcon } from 'foundations-assets/icons/components/WebsiteIcon';
import { View } from 'foundations-components/components/View';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { H4 } from 'foundations-components/transitional/components/H4';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import unescapedText from 'I18n/utils/unescapedText';
import { UsageScreenProvider, useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent, getSearchResultClickedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useCallback } from 'react';
import { EcosystemSlider } from 'trellis-ecosystem';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { Paths } from '../../constants/paths';
import { Subscreens } from '../../constants/usage';
import { isProd } from '../../utils/env';
import { CAROUSEL_SERVICES_PROD, CAROUSEL_SERVICES_QA } from '../constants/index';
import { useFilterConfigData } from '../../filters/hooks/useFilterConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function BrowsePopularPartnersSliderSection() {
  var _filterConfigResult$d;
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const cards = isProd() ? CAROUSEL_SERVICES_PROD : CAROUSEL_SERVICES_QA;
  const filterConfigResult = useFilterConfigData();
  const trackSliderButtonClicked = useCallback(direction => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: `suggestion section ${direction} arrow clicked`,
      itemIndex: 0,
      subscreen: Subscreens.SUGGESTION_SECTION
      // To do: add section, type, and value
    }));
  }, [trackMarketplaceEvent]);
  const onLinkClick = index => {
    trackMarketplaceEvent(getSearchResultClickedEvent({
      resultCount: cards.length,
      resultIndex: index,
      resultType: 'SOLUTIONS_PARTNERS'
    }));
  };
  const data = (_filterConfigResult$d = filterConfigResult.data) === null || _filterConfigResult$d === void 0 ? void 0 : _filterConfigResult$d.result.filterConfigs.PROFILE_CATALOG_SERVICES.options;
  if (!data) return null;
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    subscreen: Subscreens.SUGGESTION_SECTION,
    children: /*#__PURE__*/_jsx(View, {
      "data-test-id": "slider-section",
      marginBlockEnd: "1000",
      maxInlineSize: "100%",
      children: /*#__PURE__*/_jsx(EcosystemSlider, {
        cardWidth: 306,
        gradientColor: "fill-surface-recessed",
        onScrollButtonClick: trackSliderButtonClicked,
        scrollButtonTop: "32.5%",
        title: unescapedText('marketplaceStorefront.sliderSection.browsePartners'),
        children: cards.map((card, index) => {
          var _data$find, _card$icon, _card$color, _card$color2;
          return /*#__PURE__*/_jsx(CardWrapper, {
            margin: "0",
            minInlineSize: "306px",
            inlineSize: "306px",
            children: /*#__PURE__*/_jsx(RouterLink, {
              color: "text-core-default",
              to: `${Paths.SOLUTIONS_PARTNERS}${card.slug}`,
              onClick: () => onLinkClick(index),
              textDecoration: "none",
              children: /*#__PURE__*/_jsxs(CardSection, {
                alignItems: "center",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                paddingBlock: "300",
                minBlockSize: "104px",
                children: [/*#__PURE__*/_jsx(H4, {
                  margin: "0",
                  children: (_data$find = data.find(d => d.slug === card.slug)) === null || _data$find === void 0 ? void 0 : _data$find.text
                }), /*#__PURE__*/_jsx(IconCircle, {
                  icon: (_card$icon = card.icon) !== null && _card$icon !== void 0 ? _card$icon : WebsiteIcon,
                  color: "icon-core-default",
                  backgroundColor: (_card$color = card.color) !== null && _card$color !== void 0 ? _card$color : 'fill-accent-blue-subtle-alt',
                  borderColor: (_card$color2 = card.color) !== null && _card$color2 !== void 0 ? _card$color2 : 'fill-accent-blue-subtle-alt',
                  size: "400"
                })]
              })
            })
          }, index);
        })
      })
    })
  });
}